import React, { useEffect, useState } from "react";
import styled from "styled-components";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import NoFooterModal from "../Common/NoFooterModal";
import { BottomSectionModal } from "../../constants/assets/containers";
import InfiniteScrollDropdown from "../Common/InfiniteScrollDropdown";
import Button from "sushiweb/Button";
import * as CityActions from "../../store/actions/City";
import * as LocalityActions from "../../store/actions/Locality";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RainInputs from "../../constants/RainReporting/RainInputs.json";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";
import * as RainReportingActions from "../../store/actions/RainReporting";

const RainReportingForm = (props) => {
  const {
    handleModalClose,
    getCityList,
    getLocalityList,
    cityList,
    localityList,
    nextPageCity,
    nextPageLocality,
    getCity,
    getLocality,
    createFeedback,
  } = props;

  const [initialState, setInitialState] = useState({
    city_id: "",
    locality_id: "",
    intensity: "",
  });
  const [priorityFlag, setPriorityFlag] = useState(false);

  const allActions = MenuActionsMappings[MenuNames.GROUND_INTELLIGENCE];
  const mandatoryFields = ["city_id", "locality_id", "intensity"];
  const checkValidations = () => {
    let flag = 0;
    Object.keys(initialState).map((key) => {
      if (!initialState[key] && mandatoryFields.includes(key)) {
        flag = 1;
      }
    });
    return flag;
  };
  const handleSubmit = (e) => {
    createFeedback(initialState).then(() => {
      handleModalClose();
    });
  };
  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;
    if (key === "city_id") {
      values["locality_id"] = "";
      setPriorityFlag(true);
    } else if (key === "locality_id") {
      setPriorityFlag(false);
    }
    setInitialState(values);
  };

  const getValue = (key, val) => {
    if (key === "city") {
      const activeCity = cityList.find((item) => item.id === val);
      return activeCity ? activeCity.city_name : "";
    } else if (key === "locality") {
      const activeLocality = localityList.find((item) => item.id === val);
      return activeLocality ? activeLocality.locality_name : "";
    } else {
      return val;
    }
  };

  return (
    <GlobalCourseDetailsModalContainer id="globalCourseDetailsModal">
      <NoFooterModal
        header={true}
        heading="Rain Reporting"
        handleClose={handleModalClose}
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="saveButton"
              disabled={checkValidations()}
              onClick={handleSubmit}
              className="sushi-btn"
            >
              {"Submit"}
            </Button>
          </BottomSectionModal>
        }
      >
        <React.Fragment>
          <InfiniteScrollDropdown
            id="cityFilterDropdown"
            className="sushi-dropdown"
            priorityFlag={true}
            appliedFilters={{}}
            getActiveList={getCityList}
            nextPage={nextPageCity}
            resKey="cities"
            keyName="city_id"
            labelKey="city_name"
            getDataLabelKey="city.city_name"
            keyTypeToSet="id"
            label="City"
            handleChange={handleChange}
            remoteSearchApplicable={true}
            remoteSearchKey="startswith"
            activeElement={initialState}
            getActiveItemById={getCity}
          />
          <InfiniteScrollDropdown
            id="localityFilterDropdown"
            className="sushi-dropdown"
            priorityFlag={priorityFlag}
            setPriorityFlag={setPriorityFlag}
            appliedFilters={
              initialState.city_id ? { city_id: initialState.city_id } : {}
            }
            getActiveList={getLocalityList}
            nextPage={nextPageLocality}
            resKey="localities"
            keyName="locality_id"
            labelKey="locality_name"
            getDataLabelKey="locality.locality_name"
            keyTypeToSet="id"
            label="Locality"
            handleChange={handleChange}
            remoteSearchApplicable={true}
            remoteSearchKey="startswith"
            activeElement={initialState}
            getActiveItemById={getLocality}
          />
          {RainInputs.inputs.slice(2).map((field, index) => {
            return (
              <PaginatedReactDropdown
                options={field.options}
                disabled={field.disabled}
                labelKey={field.labelKey}
                valueKey={field.valueKey}
                labelWidth={field.labelWidth}
                key={index}
                id={field.optionsKey + "_dropdown"}
                optionsBoxId={field.optionsKey + "_options"}
                value={getValue(
                  field.optionsKey,
                  initialState[field.keyToChange]
                )}
                handleChange={handleChange}
                keyToChange={field.keyToChange}
                placeholder={field.placeholder}
                showCross
              />
            );
          })}
        </React.Fragment>
      </NoFooterModal>
    </GlobalCourseDetailsModalContainer>
  );
};

const GlobalCourseDetailsModalContainer = styled.section``;

function mapStateToProps(state) {
  const { City, Locality } = state;
  return {
    cityList: City.cityList,
    localityList: Locality.localityList,
    nextPageCity: City.nextPage,
    nextPageLocality: Locality.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getLocalityList: bindActionCreators(
      LocalityActions.getLocalityList,
      dispatch
    ),
    getCity: bindActionCreators(CityActions.getCity, dispatch),
    getLocality: bindActionCreators(LocalityActions.getLocality, dispatch),
    createFeedback: bindActionCreators(
      RainReportingActions.createFeedback,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RainReportingForm);
